const PAYMENT_MODE = [
  {
    label: 'Bank Transfer',
    value: 'Bank Transfer'
  },
  {
    label: 'Challan',
    value: 'Challan'
  },
  {
    label: 'Credit Card',
    value: 'Credit Card'
  },
  {
    label: 'Debit Card',
    value: 'Debit Card'
  },
  {
    label: 'E-NACH',
    value: 'E-NACH'
  },
  {
    label: 'EMI',
    value: 'EMI'
  },
  {
    label: 'Mobile Wallet',
    value: 'Mobile Wallet'
  },
  {
    label: 'Net Banking',
    value: 'Netbanking'
  },
  {
    label: 'Ola Money',
    value: 'Ola Money'
  },
  {
    label: 'Pay Later',
    value: 'Pay Later'
  },
  {
    label: 'UPI',
    value: 'UPI'
  },
  {
    label: 'Easy Installments',
    value: 'Easy Installments'
  },
  {
    label: 'IMPS',
    value: 'IMPS'
  },
  {
    label: 'RTGS',
    value: 'RTGS'
  },
  {
    label: 'NEFT',
    value: 'NEFT'
  },
  {
    label: 'UPI AutoPay',
    value: 'UPI AutoPay'
  },
  {
    label: 'POS UPI',
    value: 'POS UPI'
  },
  {
    label: 'POS Credit Card',
    value: 'POS Credit Card'
  },
  {
    label: 'POS Debit Card',
    value: 'POS Debit Card'
  }
];

const AppType = [
  {
    label: 'Payment Gateway',
    value: 'PG'
  },
  {
    label: 'Payment Link',
    value: 'LS'
  },
  {
    label: 'Form & Feesbuzz',
    value: 'EDU'
  },
  {
    label: 'WIRE',
    value: 'WIRE'
  }
];

const AMOUNT_RANGE = [
  {
    label: 'Is less than equal to',
    value: 'less_then'
  },
  {
    label: 'Is greater than equal to',
    value: 'greater_then'
  },
  {
    label: 'Equal to',
    value: 'equal_to'
  }
];

const TRANSACTION_SEARCH_LIST = [
  {
    label: 'Easebuzz ID',
    value: 'app_transaction_id'
  },
  {
    label: 'Merchant ID',
    value: 'merchant_id'
  },
  {
    label: 'Bank Reference Number',
    value: 'bank_ref_number'
  },
  {
    label: 'Partner Payout ID',
    value: 'partner_payout_id'
  }
];

const TRANSACTION_FILTER_LIST = [
  {
    label: 'Payment Mode',
    attr: 'transaction_type',
    data: PAYMENT_MODE
  },
  {
    label: 'Product',
    attr: 'app_type',
    data: AppType
  },
  {
    label: 'Date Range',
    attr: 'transaction_date',
    type: 'DateRange'
  },
  {
    label: 'Amount Range',
    attr: 'transaction_amount',
    type: 'AmountRange'
  }
];

export { PAYMENT_MODE, AMOUNT_RANGE, TRANSACTION_SEARCH_LIST, TRANSACTION_FILTER_LIST, AppType };
